import { NgClass } from "@angular/common";
import { Component, ElementRef, input, Input, ViewChild } from "@angular/core";
import { SvgIconComponent } from "@ponder-shared/components/svg-icon.component";
import { clamp } from "@ponder-shared/utils/general";
import { SvgIcon } from "@ponder-shared/utils/svgIcons";
import { AdvancedSearchParameter, AdvancedSearchService } from "../advanced-search.service";

@Component({
    selector: "advanced-search-range",
    imports: [NgClass, SvgIconComponent],
    templateUrl: "./advanced-search-range.component.html"
})
export class AdvancedSearchRangeComponent {
    @ViewChild("fromInput") private fromInputRef!: ElementRef<HTMLInputElement>;
    @ViewChild("toInput") private toInputRef!: ElementRef<HTMLInputElement>;

    @Input({ required: true }) public type!: AdvancedSearchParameter;
    @Input({ required: true }) public min!: number;
    @Input({ required: true }) public max!: number;

    public from?: number;
    public to?: number;
    
    public hasValue: boolean = false;
    public closeSvgIcon: SvgIcon = SvgIcon.Close;
    
    public constructor(private advancedSearch: AdvancedSearchService) {

    }

    public onChangeFrom(value: string): void {
        if (value.length > 0) {
            this.from = +value;

            if (!this.to) {
                this.toInputRef.nativeElement.value = this.max + "";
                this.to = this.max;
            }

            this.hasValue = true;
        } else {
            this.from = undefined;
            this.hasValue = this.to ? true : false;
        }

        this.keepSane();
        this.advancedSearch.setRange(this.type, this.from, this.to);
    }

    public onChangeTo(value: string): void {
        if (value.length > 0) {
            this.to = +value;

            if (!this.from) {
                this.fromInputRef.nativeElement.value = this.min + "";
                this.from = this.min;
            }

            this.hasValue = true;
        } else {
            this.to = undefined;
            this.hasValue = this.from ? true : false;
        }

        this.keepSane();
        this.advancedSearch.setRange(this.type, this.from, this.to);
    }

    private keepSane(): void {
        this.from = (this.from != undefined) ? clamp(this.from, this.min, this.max) : this.min;
        this.to = (this.to != undefined) ? clamp(this.to, this.min, this.max) : this.max;

        if (this.from > this.to) {
            var t = this.from;
            this.from = this.to;
            this.to = t;
        }

        this.fromInputRef.nativeElement.value = this.from + "";
        this.toInputRef.nativeElement.value = this.to + "";
    }

    public onClear(): void {
        this.fromInputRef.nativeElement.value = "";
        this.toInputRef.nativeElement.value = "";
        this.from = undefined;
        this.to = undefined;
        this.hasValue = false;
        this.advancedSearch.setRange(this.type, this.from, this.to);
    }
}